/**
 * Query normalization and hashing utilities for cache lookup
 */

/**
 * Normalize a query string for consistent cache matching
 * - Trim leading/trailing whitespace
 * - Convert to lowercase
 * - Collapse multiple spaces into single space
 * @param {string} query - The user's query
 * @returns {string} - Normalized query
 */
export function normalizeQuery(query) {
  return query.trim().toLowerCase().replace(/\s+/g, ' ');
}

/**
 * Generate a hash string for a query
 * Uses a simple but effective hash for cache lookup
 * @param {string} query - The user's query
 * @returns {string} - Hash string prefixed with 'q_'
 */
export function hashQuery(query) {
  const normalized = normalizeQuery(query);

  // Simple djb2 hash algorithm
  let hash = 5381;
  for (let i = 0; i < normalized.length; i++) {
    const char = normalized.charCodeAt(i);
    hash = ((hash << 5) + hash) + char; // hash * 33 + char
    hash = hash & hash; // Convert to 32-bit integer
  }

  return 'q_' + Math.abs(hash).toString(36);
}
